<!-- Copyright: Seán I. O'Donoghue -->

<template>
  <div v-show="isBusy" class="busy-overlay">
    <div class="busy-inner">
      <progress />
      <div v-if="busyMessage" class="busy-message">{{ busyMessage }}</div>
    </div>
  </div>
</template>

<script setup>
defineProps({isBusy: {default: false}, busyMessage: {default: "Please wait…"}});
</script>

<style scoped>
.busy-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.65);
  backdrop-filter: blur(2px);
  pointer-events: auto;
  z-index: 10;
}
.busy-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
}
progress {
  width: 140px;
  height: 10px;
}
.busy-message {
  font-size: 0.95rem;
}
</style>
